//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BrowserNotSupportedOverlay",
  computed: {
    browser() {
      return navigator.sayswho;
    }
  }
});